import { ChakraProvider, defaultSystem } from "@chakra-ui/react"
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister"
import { QueryClient } from "@tanstack/react-query"
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client"
import { ColorModeProvider } from "components/ui-old/color-mode"
import { Toaster } from "config"
import { DataProvider } from "hooks/useData"
import { ThemeProvider } from "next-themes"
import { BrowserRouter } from "react-router"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 60, 
            gcTime: 1000 * 60 * 60 * 48
        }
    }
})

// Ao retornar do link de confirmação de e-mail Brevo, o cache persistido no localStorage
// ainda tem update_data_at: null. Limpamos antes da hidratação para que useDistributor()
// busque dados frescos e o PrivateRoutes não bloqueie na tela de atualização cadastral.
if (new URLSearchParams(window.location.search).get('brevo_confirmed') === '1') {
    localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE')
}

const persister = createSyncStoragePersister({ storage: window.localStorage })

export default function Providers({ children }){
    return(
    <ChakraProvider value={defaultSystem}>
        <ColorModeProvider>
            <DataProvider>
                <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
                    <BrowserRouter>
                        { children }
                    </BrowserRouter>
                    <Toaster />
                </PersistQueryClientProvider>
            </DataProvider>
        </ColorModeProvider>
    </ChakraProvider>
    )
}